(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["offers"] && !Shopify.designMode) return;
  try {
    (function () {
  function wire(root) {
    var vc = parseInt(root.getAttribute('data-visible') || '2', 10);
    root.querySelectorAll('.sb-offers__bar').forEach(function (bar) {
      bar.addEventListener('click', function () {
        var row = bar.parentNode;
        var open = row.classList.toggle('is-open');
        bar.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    root.querySelectorAll('.sb-offers__copy').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var c = btn.getAttribute('data-code');
        var prev = btn.getAttribute('data-label') || btn.textContent;
        btn.setAttribute('data-label', prev);
        var done = function () {
          btn.classList.add('is-copied');
          btn.textContent = 'Copied';
          setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = prev; }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(c).then(done).catch(done);
        } else {
          var t = document.createElement('textarea');
          t.value = c; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (err) {}
          t.remove(); done();
        }
      });
    });
    var rows = root.querySelectorAll('.sb-offers__row');
    var more = root.querySelector('.sb-offers__more');
    var hidden = Math.max(0, rows.length - vc);
    rows.forEach(function (r, i) { if (i >= vc) { r.classList.add('is-hidden'); } });
    if (more) {
      if (hidden === 0) {
        more.style.display = 'none';
      } else {
        var label = '+' + hidden + (hidden === 1 ? ' more offer' : ' more offers');
        more.style.display = '';
        more.textContent = label;
        more.addEventListener('click', function () {
          var expanded = more.getAttribute('data-expanded') === 'true';
          rows.forEach(function (r, i) { if (i >= vc) { r.classList.toggle('is-hidden', expanded); } });
          more.setAttribute('data-expanded', (!expanded).toString());
          more.textContent = expanded ? label : 'Show less';
        });
      }
    }
  }
  function boot() {
    document.querySelectorAll('.sb-offers').forEach(function (root) {
      if (root.getAttribute('data-sb-init') === '1') { return; }
      if (!root.querySelector('.sb-offers__row')) { return; }
      root.setAttribute('data-sb-init', '1');
      wire(root);
      root.style.display = '';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
